import Application, { ApplicationDTO } from 'models/application/config/Application';
import { CurrencyDTO } from '../currency/Currency';

export interface ConfigDTO {
	application: ApplicationDTO;
	currencies: CurrencyDTO;
	vapid_public_key: string;
	workflows_enabled: boolean;
}

export default class Config {
	private readonly _application: Application;
	private readonly _currencies: CurrencyDTO;
	private readonly _vapidPublicKey: string;
	private readonly _workflowsEnabled: boolean;

	constructor(config: ConfigDTO) {
		/**
		 * @type {Object}
		 */
		this._application = new Application(config.application);
		/**
		 * @type {Object[]}
		 */
		this._currencies = config.currencies;
		/**
		 * @type string
		 */
		this._vapidPublicKey = config.vapid_public_key;
		/**
		 * @type boolean
		 */
		this._workflowsEnabled = config.workflows_enabled;
	}

	application() {
		return this._application;
	}

	currencies() {
		return this._currencies;
	}

	vapidPublicKey() {
		return this._vapidPublicKey;
	}

	workflowsEnabled() {
		return this._workflowsEnabled;
	}
}
